import { useDispatch, useSelector } from "react-redux";
import IconButton from "../IconButton";
import { MainActions, PaybackControlButton } from "./styled";
import { togglePlayer } from "../../redux/Slice/playerSlice";
import Loader from "../Loader/Loader";
import { radioInfoTypeSelector } from "../../redux/selectors/radioInfoSelector";
import {
  playerInfoSelector,
  selectCurrentEntity,
} from "../../redux/selectors/playerSelector";

import FooterPlayerRatingActions from "./FooterPlayerRatingActions";
import { useTrackNavigation } from "../../hooks/useTrackNavigation";

export const FooterPlayerMainActions = () => {
  const dispatch = useDispatch();
  const {
    isPlaying,
    currentContent,
    currentStreamType,
    audioType,
    progress,
    loaded,
  } = useSelector(playerInfoSelector);

  const currentEntity = useSelector(selectCurrentEntity);

  const isRelease = currentEntity === "release";

  const { loading } = useSelector((state) =>
    radioInfoTypeSelector(state, currentStreamType),
  );

  const { handleSkip, hasPrevious, hasNext } = useTrackNavigation();

  const isLoading = progress > loaded || loading;

  const handlePlayClick = (e) => {
    e.stopPropagation();

    dispatch(togglePlayer());
  };

  const handleSkipClick = (e, direction) => {
    e.stopPropagation();

    handleSkip(direction);
  };

  return (
    <MainActions audioType={audioType}>
      <FooterPlayerRatingActions
        isRelease={isRelease}
        rating={currentContent["user_rating"]}
        trackId={currentContent?.id}
      />
      {audioType !== "stream" && (
        <IconButton
          disabled={!hasPrevious}
          onPointerUp={(event) => handleSkipClick(event, -1)}
        >
          <img src="/skip-back.svg" alt="Скип назад" />
        </IconButton>
      )}
      <IconButton as={PaybackControlButton} onPointerUp={handlePlayClick}>
        {isLoading ? (
          <Loader />
        ) : (
          <img
            src={isPlaying ? "/circle-pause.svg" : "/circle-play.svg"}
            alt={isPlaying ? "Пауза" : "Воспроизвести"}
          />
        )}
      </IconButton>
      {audioType !== "stream" && (
        <IconButton
          disabled={!hasNext}
          onPointerUp={(event) => handleSkipClick(event, 1)}
        >
          <img src="/skip-next.svg" alt="Скип далее" />
        </IconButton>
      )}
      <FooterPlayerRatingActions
        isRelease={isRelease}
        rating={currentContent["user_rating"]}
        trackId={currentContent?.id}
        isLike
      />
    </MainActions>
  );
};
